// extracted by mini-css-extract-plugin
export default {"Root":"Checkbox_Root__x5EX+"};